class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.cartCrossSell = document.querySelector('cart-cross-sell');
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy, isSliderCrossSell) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    const customEvent = new Event('cartUpdated');
    document.dispatchEvent(customEvent);

    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active')

      if (triggeredBy === undefined && this.cartCrossSell != null) {
        //triggeredBy is undefined when you are submitting form
        this.cartCrossSell.openModal();
        this.cartCrossSell.classList.add('animate', 'active');

        const looxFloatContainer = document.querySelector('.loox-float-toggler-container')
        if (looxFloatContainer) looxFloatContainer.style.display = 'none';
      };

      if (isSliderCrossSell === true) {
        this.cartCrossSell.classList.remove('animate', 'active');
        this.cartCrossSell.closeModal();
      }


    });

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    if (document.querySelector('#fb-root') != null) {
      document.querySelector('#fb-root').style.display = "none";
    }

    document.documentElement.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');

    if (this.cartCrossSell != null) {
      this.cartCrossSell.closeModal();
      this.cartCrossSell.classList.remove('animate', 'active');
    }

    removeTrapFocus(this.activeElement);
    document.documentElement.classList.remove('overflow-hidden');

    if (document.querySelector('#fb-root') != null) {
      document.querySelector('#fb-root').style.display = "block";
    }
    //popbrush specific adapter pour l'application d'avis
    if (document.querySelector('.loox-float-toggler-container')) {
      document.querySelector('.loox-float-toggler-container').style.display = 'flex';
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState, isSliderCrossSell = false) {

    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open(undefined, isSliderCrossSell);
    });
    initSwiperPicto();
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

function initSwiperPicto() {
  if (document.querySelector('.drawer-picto-text-contain') != null) {
    const swiperPictoCart = new Swiper('.drawer-picto-text-contain.swiper', {
      // Optional parameters
      direction: 'horizontal',
      slidesPerView: 1,
      autoplay: {
        delay: 2000,
        pauseOnMouseEnter: false,
      },
      speed: 500,
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: '.swiper-pagination',
      },
    });
  }
}
initSwiperPicto();
